import type {PostPlatform, PostWidget} from "./chat-runtime";
import type {SentimentPost} from "./influencers-api";

/**
 * Map site string (from InfegySentimentPost) to PostWidget platform enum
 */
function mapSiteToPlatform(site: string | null): PostPlatform {
  if (!site) return "other";

  const s = site.toLowerCase();

  if (s.includes("twitter") || s.includes("x.com") || s === "x") return "x";
  if (s.includes("instagram")) return "instagram";
  if (s.includes("facebook")) return "facebook";
  if (s.includes("linkedin")) return "linkedin";
  if (s.includes("tiktok")) return "tiktok";
  if (s.includes("youtube")) return "youtube";

  return "other";
}

/**
 * Convert InfegySentimentPost to PostWidget format for use with SocialPostCard
 */
export function sentimentPostToPostWidget(post: SentimentPost): PostWidget {
  return {
    id: post.id,
    platform: mapSiteToPlatform(post.site),
    author_handle: "",
    author_name: null,
    author_avatar: null,
    text: post.body || "",
    url: post.link || "",
    date: post.published,
    sentiment: post.sentiment,
    engagement: post.total_engagements || 0,
  };
}
